export const toggleLeftPaneCommand = "MJU0Te";
export default {toggleLeftPaneCommand};